import * as React from 'react';
import { FieldsEnumKeys, IField } from '../../hooks/usePersonalData';
import { InputComponent, SelectComponent, TextareaComponent } from './ControlComponents';
interface IRequestFormPersonalInfo_Row {
    field: IField;
    title?: string;
    label?: string;
    type?: string;
    className?: string;
    children?: JSX.Element;
    onChange?: Function;
}

const fieldTypes = {
    selectType: (fieldName) => {
        return [
            FieldsEnumKeys.isFemale,
            FieldsEnumKeys.countryCode,
            FieldsEnumKeys.selectedAirportIndex,
        ].includes(fieldName as FieldsEnumKeys);
    },
    textareaType: (fieldName) => {
        return [FieldsEnumKeys.message].includes(fieldName as FieldsEnumKeys);
    },
    inputType: (fieldName) => {
        return [
            FieldsEnumKeys.firstname,
            FieldsEnumKeys.lastname,
            FieldsEnumKeys.phone,
            FieldsEnumKeys.email,
            FieldsEnumKeys.newsletterSubscription,
        ].includes(fieldName as FieldsEnumKeys);
    },
    customPhone: (fieldName) => {
        return [FieldsEnumKeys.phone].includes(fieldName as FieldsEnumKeys);
    },
};

const RequestFormPersonalInfo_Row = (props: IRequestFormPersonalInfo_Row) => {
    const { label, title, field, className, children, type, onChange } = props;
    const compName = 'form-row';
    const getField = (): JSX.Element => {
        if (fieldTypes.inputType(field.name)) {
            return (
                <InputComponent
                    title={title || label}
                    type={type}
                    field={field}
                    className={className}
                />
            );
        } else if (fieldTypes.selectType(field.name)) {
            return (
                <SelectComponent
                    title={title || label}
                    options={field.control.options}
                    field={field}
                    className={className}
                    onChange={onChange}
                    key={field.control.value?.toString()}
                />
            );
        } else if (fieldTypes.textareaType(field.name)) {
            return <TextareaComponent className={className} field={field} rows={2} cols={49} />;
        }
    };
    let fieldElement = children || getField();
    return (
        <>
            {field?.active && fieldElement && (
                <div className={`${compName}`}>
                    {label ? (
                        <label htmlFor={field.name} className={`${compName}__cell`}>
                            <span className={`${compName}__cell__label-holder`}>
                                <span className={`${compName}__cell__label-holder__label`}>
                                    {label}
                                </span>
                            </span>
                        </label>
                    ) : (
                        <div className={`${compName}__cell`}></div>
                    )}
                    <div className={`${compName}__cell`}>
                        <div className={`${compName}__cell__control-holder`}>
                            <div className={`${compName}__cell__control-holder__control`}>
                                {fieldElement}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default RequestFormPersonalInfo_Row;
